import { v4 as uuid } from "uuid";

const myLinks = [
  {
    id: uuid(),
    links: "https://github.com/Kinguche2",
    icons: "fa-brands fa-github class-purple",
    label: "connect with me on github ",
  },
  {
    id: uuid(),
    links: "https://www.linkedin.com/in/uche-ogbonna-989621114/",
    icons: "fa-brands fa-linkedin class-purple",
    label: "connect with me on linkedin ",
  },
  {
    id: uuid(),
    links: "https://twitter.com/ucheogbonnak",
    icons: "fa-brands fa-twitter class-purple",
    label: "connect with me on twitter ",
  },
  {
    id: uuid(),
    links: "mailto:ucheogbonnak@gmail.com",
    icons: "fa-solid fa-envelope class-purple",
    label: "Send me an email ",
  },
  {
    id: uuid(),
    links: "https://www.instagram.com/uches_wall/",
    icons: "fa-brands fa-instagram class-purple",
    label: "connect with me on instagram ",
  },
  {
    id: uuid(),
    links: "tel:+2349068973430",
    icons: "fa-solid fa-phone class-purple",
    label: "Call me on my cellphone number ",
  },
  {
    id: uuid(),
    links: "https://wa.me/2349068973430",
    icons: "fa-brands fa-square-whatsapp class-purple",
    label: "connect with me on WhatsApp",
  },
];

export default myLinks;
